var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81341 12.8571C7.81341 12.8571 5.66543 12.6404 5.07095 14.8473C4.47646 17.0542 7.81343 17.4286 7.81343 17.4286C7.81343 17.4286 6.43583 19.9572 8.37527 20.8571C10.3147 21.7571 11.7464 19.7143 11.7464 19.7143C11.7464 19.7143 11.7464 22 13.9939 22C16.2413 22 16.8032 19.7143 16.8032 19.7143C16.8032 19.7143 19.2597 21.4286 20.7362 19.7143C22.2128 18 20.7362 16.8571 20.7362 16.8571C20.7362 16.8571 23.5455 15.1429 22.905 13.1921C22.2646 11.2414 20.1743 11.7143 20.1743 11.7143C20.1743 11.7143 20.7362 10 19.6125 8.85714C18.4888 7.71429 16.8032 8.85714 16.8032 8.85714C16.8032 8.85714 16.8032 6 13.9939 6C11.1846 6 11.1846 8.85714 11.1846 8.85714C11.1846 8.85714 9.499 7.71429 8.04329 8.96164C6.58759 10.209 7.81341 12.8571 7.81341 12.8571Z",
    stroke: "#050022",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.63b5a47a92c9e3c5a3c8d5506f9f4d89.svg";
export { ForwardRef as ReactComponent };